import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "items", "wrap", "getItemColor", "getItemIcon", "getItemImage", "getItemLogo", "getItemName", "getItemTagName", "getItemAttributes", "getItemDisabled", "getItemRef", "getItemInvert", "getItemBgColor", "visibleCount", "size", "disabled", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef } from 'react';
import { cnBem, combineRefs } from '@carnica/utils';
import { Avatar } from "../Avatar";
import { avatarGroupGapMap, composePreparedProps, getAvatarProps } from "./utils";
import styles from "./styles.pcss";
import { useVisibleItems } from "./hooks/useVisibleItems";
var cnAvatarGroup = cnBem('avatar-group', styles);
var AvatarGroupRender = function AvatarGroupRender(props, ref) {
  var _composePreparedProps = composePreparedProps(props),
    className = _composePreparedProps.className,
    _composePreparedProps2 = _composePreparedProps.items,
    items = _composePreparedProps2 === void 0 ? [] : _composePreparedProps2,
    wrap = _composePreparedProps.wrap,
    getItemColor = _composePreparedProps.getItemColor,
    getItemIcon = _composePreparedProps.getItemIcon,
    getItemImage = _composePreparedProps.getItemImage,
    getItemLogo = _composePreparedProps.getItemLogo,
    getItemName = _composePreparedProps.getItemName,
    getItemTagName = _composePreparedProps.getItemTagName,
    getItemAttributes = _composePreparedProps.getItemAttributes,
    getItemDisabled = _composePreparedProps.getItemDisabled,
    getItemRef = _composePreparedProps.getItemRef,
    getItemInvert = _composePreparedProps.getItemInvert,
    getItemBgColor = _composePreparedProps.getItemBgColor,
    visibleCount = _composePreparedProps.visibleCount,
    _composePreparedProps3 = _composePreparedProps.size,
    size = _composePreparedProps3 === void 0 ? 'm' : _composePreparedProps3,
    disabled = _composePreparedProps.disabled,
    style = _composePreparedProps.style,
    otherProps = _objectWithoutProperties(_composePreparedProps, _excluded);
  var _useVisibleItems = useVisibleItems(items, size, visibleCount),
    parentRef = _useVisibleItems.parentRef,
    hiddenCount = _useVisibleItems.hiddenCount,
    visibleItems = _useVisibleItems.visibleItems;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnAvatarGroup({
      wrap: wrap
    }, [className]),
    ref: combineRefs([ref, parentRef]),
    style: _objectSpread(_defineProperty({}, '--avatar-group-gap', "".concat(avatarGroupGapMap[size], "px")), style)
  }, otherProps, {
    "data-t-id": "components-AvatarGroup"
  }), visibleItems.map(function (item, i) {
    var _getItemDisabled, _getItemAttributes;
    return /*#__PURE__*/React.createElement(Avatar, _extends({
      className: cnAvatarGroup('item'),
      disabled: (_getItemDisabled = getItemDisabled(item)) !== null && _getItemDisabled !== void 0 ? _getItemDisabled : disabled,
      key: cnAvatarGroup('item', {
        i: i
      }),
      ref: getItemRef(item),
      size: size,
      tagName: getItemTagName(item)
    }, getAvatarProps(item, {
      getItemInvert: getItemInvert,
      getItemIcon: getItemIcon,
      getItemImage: getItemImage,
      getItemLogo: getItemLogo,
      getItemName: getItemName,
      getItemColor: getItemColor,
      getItemBgColor: getItemBgColor
    }), (_getItemAttributes = getItemAttributes(item)) !== null && _getItemAttributes !== void 0 ? _getItemAttributes : {}));
  }), hiddenCount > 0 && /*#__PURE__*/React.createElement(Avatar, {
    className: cnAvatarGroup('item'),
    disabled: disabled,
    name: "+".concat(hiddenCount),
    size: size
  }));
};
export var AvatarGroup = /*#__PURE__*/forwardRef(AvatarGroupRender);